var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVoicemail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98633 12C2.98633 9.74545 4.81399 7.91779 7.06852 7.91779C9.32305 7.91779 11.1507 9.74545 11.1507 12C11.1507 12.7605 10.9427 13.4725 10.5805 14.0822H13.4196C13.0573 13.4725 12.8493 12.7605 12.8493 12C12.8493 9.74545 14.677 7.91779 16.9315 7.91779C19.186 7.91779 21.0137 9.74545 21.0137 12C21.0137 14.2545 19.186 16.0822 16.9315 16.0822H7.06852C4.81399 16.0822 2.98633 14.2545 2.98633 12ZM7.06852 14.0822C8.21848 14.0822 9.15071 13.1499 9.15071 12C9.15071 10.85 8.21848 9.91779 7.06852 9.91779C5.91856 9.91779 4.98633 10.85 4.98633 12C4.98633 13.1499 5.91856 14.0822 7.06852 14.0822ZM16.9315 9.91779C15.7816 9.91779 14.8493 10.85 14.8493 12C14.8493 13.1499 15.7816 14.0822 16.9315 14.0822C18.0815 14.0822 19.0137 13.1499 19.0137 12C19.0137 10.85 18.0815 9.91779 16.9315 9.91779Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVoicemail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Voicemail.023beefc20eec2b17156463e7205f0b5.svg";